import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useEventListingStore, { setEventSearch, updateEventFilters } from 'layout/Listing/variants/events/store';

import { hasArrayValues } from 'utils/array/arrays';

const useEventFilterSearchParam = () => {
  const activeFilters = useEventListingStore(state => state.filters);
  const activeSearch = useEventListingStore(state => state.search);
  const { push } = useRouter();

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const search = params?.get('s');
    const filters = params?.get('category');

    search && search !== '' && setEventSearch(search);
    filters && filters !== '' && updateEventFilters(filters.split(','));
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    hasArrayValues(activeFilters) ? params.set('category', activeFilters.join(',')) : params.delete('category');
    activeSearch ? params.set('s', activeSearch) : params.delete('s');

    const newUrl = url.toString();

    push(newUrl, newUrl, { shallow: true, scroll: false });
  }, [activeFilters, activeSearch]);
};

export default useEventFilterSearchParam;
